import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';
import { Table, Image, Button, Row, Form, Modal, Col } from 'react-bootstrap';
import Loader from 'react-loader-spinner';
// import Switch from "react-switch";
import LeftSideNavigation from '../../../vendorDashboardComponents/navigationSection/LeftSideNavigation';
import HomeReusableTopBarNavigation from '../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation';
import { SuperAdminFilter } from '../../superAdminReusable/reusableTable/SuperAdminTopTextSearchIcon';
import SuperAdminOfferDelete from '../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminOfferDelete';
import ViewOfferDetailsOfflineAdmin from './ViewOfferDetailsOfflineAdmin';
import ViewOfferDetailsOnline from './ViewOfferDetailsOnline';
import BasicPagination from '../../../Pagination/Pagination';
import { AmealioLoader } from '../../../Loader/AmealioLoader';
import ReadMoreReact from 'read-more-react';
import Alert from 'react-s-alert';
import {
  getAllAdminOffers,
  changeAdminOfferStatus,
} from '../../../../store/actions/SuperAdminActions/adminManageOffers';
import {
  super_admin_get_selected_restaurant_list,
  super_admin_get_city,
} from '../../../../store/actions/SuperAdminActions/superAdminOnlineAndOfflineAction';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import ListMarchantTableHead from './TableHeadBody/ListMarchantTableHead';
import ListMerchantTableBody from './TableHeadBody/ListMerchantTableBody';
import isEmpty from '../../../../store/validation/is-Empty';
import { SortComponent } from '../../../reusableComponents/SortAndFilterComponent/SortComponent';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import {
  Paper,
  InputBase,
  IconButton,
  FormControl,
  Select,
  InputLabel,
  Menu,
  MenuItem,
  Switch,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { RightSideCountTop } from '../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports';
import CSVDownloader from '../../../reusableComponents/csvDownload/csvDownload';
import ViewOfferDetailsOnlineAdmin from './ViewOfferDetailsOnlineAdmin';
import SelectFilter from '../../../reusableComponents/selectFilter';

import { makeStyles } from '@material-ui/core/styles';

// Animations
import styled, { keyframes } from 'styled-components';
import { zoomIn } from 'react-animations';
import { errorAlert } from '../../../../function/alert';
import ShareLinkModal from '../../../reusableComponents/ShareLinkModal';
const zoomAnimation = keyframes`${zoomIn}`;
const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

const sortByCode = [
  { id: 0, title: 'Offer Name A-Z' },
  { id: 1, title: 'Offer Name Z-A' },
];

const useStyles = makeStyles({
  switchBase: {
    color: '#FFFFFF',
    '&$checked': {
      color: '#FFFFFF',
    },
    '&$checked + $track': {
      backgroundColor: '#7cfc00',
    },
  },
  checked: {},
  track: {},
});

const SuperAdminOffers = (props) => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [displaySearch, setDisplaySearch] = useState(false);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  // const [sortBy, setSortBy] = useState("Offer Name A-Z");
  const [showView, setShowView] = useState(false);
  const [showView2, setShowView2] = useState(false);
  const [showFilter, setShowFilter] = useState(false);

  const [readMoreLength, setReadMoreLength] = useState(10);

  const [offerType, setOfferType] = useState('All');
  const [status, setStatus] = useState('All');

  const [searchByOfferType, setSearchByOfferType] = useState('All');
  const [searchByStatus, setSearchByStatus] = useState('All');
  /******************* View Status ****************/
  const [selectedTab, setSelectedTab] = useState('1');
  const handleTab = (e) => {
    setSelectedTab(e);
  };

  const onClickSearchButtonTop = () => {
    setDisplaySearch(!displaySearch);
    setShowFilter(false);
  };

  const token = props.auth.user.accessToken;
  /*******************************
   * @DESC Date Range Filter
   *******************************/
  const [dateQuery, setDateQuery] = useState('');
  useEffect(() => {
    dispatch(
      getAllAdminOffers(
        token,
        onSuccessGetAdminOffer,
        onErrorGetAdminOffer,
        dateQuery.startDate === undefined
          ? moment().subtract(30, 'days').format('YYYY-MM-DD')
          : dateQuery.startDate,
        dateQuery.endDate === undefined
          ? moment().format('YYYY-MM-DD')
          : dateQuery.endDate
      )
    );
  }, [dateQuery]);

  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };

  const [openMerchantModel, setMerchantModel] = useState(false);
  const handleMerchantModelClose = () => setMerchantModel(false);
  const handleMerchantModelShow = (data) => {
    props.super_admin_get_selected_restaurant_list(
      token,
      data && data?._id,
      onSuccesslist
    );
    props.super_admin_get_city(
      token,
      data?.country,
      data?.state,
      onSuccessstatelist
    );
    setMerchantModel(true);
  };

  const onSuccesslist = () => {
    setState({
      ...state,
      restaurantType: '',
    });
  };

  const onSuccessstatelist = () => {
    setState({
      ...state,
      restaurantType: '',
    });
  };

  const searchClick = () => {
    if (status === 'Active') {
      setSearchByStatus('Active');
    } else if (status === 'Inactive') {
      setSearchByStatus('Inactive');
    } else {
      setSearchByStatus('All');
    }
    if (offerType === 'Online') {
      setSearchByOfferType('Online');
    } else if (offerType === 'Offline') {
      setSearchByOfferType('Offline');
    } else {
      setSearchByOfferType('All');
    }
  };

  const handleShowFilter = () => {
    setShowFilter(!showFilter);
    setDisplaySearch(false);
  };

  const cancelClick = () => {
    setShowFilter(!showFilter);
    setDisplaySearch(false);
    setSearchByStatus('All');
    setSearchByOfferType('All');
    setStatus('All');
    setOfferType('All');
  };
  const onSuccessEdit = () => {};
  const onErrorEdit = (data) => {
    errorAlert(data);
  };

  const mainCarousel = (carousel, status, offerId) => {
    const formData = {};
    if (!status) {
      Alert.error(
        `<h4>Please activate offer first then enable main carousel</h4>`,
        {
          position: 'top-right',
          effect: 'bouncyflip',
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        }
      );
      formData.send_to_carousel = false;
    } else if (carousel === undefined) {
      formData.send_to_carousel = true;
    } else {
      formData.send_to_carousel = !carousel;
    }
    props.changeAdminOfferStatus(
      token,
      offerId,
      formData,
      onSuccessEdit,
      onErrorEdit
    );
  };
  const toggleFunction = (status, offerId) => {
    const formData = {};
    if (!status) {
      formData.active = !status;
    } else {
      formData.active = !status;
      formData.send_to_carousel = false;
    }
    props.changeAdminOfferStatus(
      token,
      offerId,
      formData,
      onSuccessEdit,
      onErrorEdit
    );
  };
  const togglePrimaryFunction = (status, offerId) => {
    const formData = {};
    formData.mark_as_primary = !status;
    props.changeAdminOfferStatus(
      token,
      offerId,
      formData,
      onSuccessEdit,
      onErrorEdit
    );
  };

  const [data, setData] = useState();
  const handleShowView = (dataForModal) => {
    setData(dataForModal);
    setShowView(true);
  };
  const handleCloseView = () => setShowView(false);
  const handleCloseView2 = () => setShowView2(false);
  const handleShowView2 = (dataForModal) => {
    setData(dataForModal);
    setShowView2(true);
    setSelectedTab('1');
  };

  const onSuccessGetAdminOffer = () => {
    setLoading(false);
  };

  const onErrorGetAdminOffer = () => {
    setLoading(false);
  };

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const [sortByDay, setSortByDay] = useState(4);
  const [startDay, setStartDay] = useState('');
  const [endDay, setEndDay] = useState('');

  const [sortBy, setSortBy] = useState('');
  const handleClick = (event) => {
    setState({
      ...state,
      anchorEl: event.currentTarget,
    });
  };

  const handleSelect = (value) => (e) => {
    setSortBy(value);
    handleClose();
  };

  /************************************
   * Sort Offers Data
   ***********************************/
  let numbersArr = [];
  let charArr = [];
  let mergeArr = [];

  function stringContainsNumber(_string) {
    return /\d/.test(_string);
  }
  props &&
    props.allSuperAdminOffers &&
    props.allSuperAdminOffers.forEach((elements) => {
      if (stringContainsNumber(elements.name.charAt(0))) {
        numbersArr.push(elements);
      } else {
        charArr.push(elements);
      }
    });
  numbersArr &&
    numbersArr.sort((a, b) => {
      let numbersArr_A = a && a.name && a.name.toUpperCase(); // ignore upper and lowercase
      let numbersArr_B = b && b.name && b.name.toUpperCase(); // ignore upper and lowercase
      let numbersArrA = numbersArr_A.replace(/[^0-9]+/gi, '');
      let numbersArrB = numbersArr_B.replace(/[^0-9]+/gi, '');
      if (sortBy === 'A-Z') {
        return numbersArrA - numbersArrB;
      } else if (sortBy === 'Z-A') {
        return numbersArrB - numbersArrA;
      }
    });

  if (sortBy === 'Z-A') {
    console.log('Enter');
    mergeArr = charArr.concat(numbersArr);
  } else {
    mergeArr = numbersArr.concat(charArr);
  }

  let filteredData =
    charArr &&
    charArr.sort(function (a, b) {
      let name_A = a && a.name && a.name.toUpperCase(); // ignore upper and lowercase
      let name_B = b && b.name && b.name.toUpperCase(); // ignore upper and lowercase
      let nameA = name_A.replace(/[^A-Z]+/gi, '');
      let nameB = name_B.replace(/[^A-Z]+/gi, '');
      if (sortBy === 'A-Z') {
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
      } else if (sortBy === 'Z-A') {
        if (nameB < nameA) {
          return -1;
        }
        if (nameB > nameA) {
          return 1;
        }
      }
      // names must be equal
      return 0;
    });
  filteredData =
    sortBy === 'Z-A'
      ? filteredData.concat(numbersArr)
      : numbersArr.concat(filteredData);

  var filterOffers = filteredData.filter((offer) => {
    return (
      ((offer &&
        offer.name &&
        offer.name.toLowerCase().includes(search.toLowerCase())) ||
        (offer &&
          offer.coupon_code &&
          offer.coupon_code.toLowerCase().includes(search.toLowerCase()))) &&
      ((searchByStatus === 'All' && searchByOfferType === 'All' && offer) ||
        (searchByStatus === 'Active' &&
          searchByOfferType === 'All' &&
          offer.active) ||
        (searchByStatus === 'Inactive' &&
          searchByOfferType === 'All' &&
          !offer.active) ||
        (searchByOfferType === 'Online' &&
          searchByStatus === 'All' &&
          offer.isOnline) ||
        (searchByOfferType === 'Offline' &&
          searchByStatus === 'All' &&
          !offer.isOnline) ||
        (searchByOfferType === 'Online' &&
          searchByStatus === 'Active' &&
          offer.isOnline &&
          offer.active) ||
        (searchByOfferType === 'Online' &&
          searchByStatus === 'Inactive' &&
          offer.isOnline &&
          !offer.active) ||
        (searchByOfferType === 'Offline' &&
          searchByStatus === 'Active' &&
          !offer.isOnline &&
          offer.active) ||
        (searchByOfferType === 'Offline' &&
          searchByStatus === 'Inactive' &&
          !offer.isOnline &&
          !offer.active))
    );
  });

  // if (sortByDay !== 4) {
  //   filterOffers = filterOffers.filter((item) => {
  //     return (
  //       (startDay <= moment(item.createdAt).format("YYYY-MM-DD") ||
  //         startDay <= moment(item.updatedAt).format("YYYY-MM-DD")) &&
  //       (moment(item.createdAt).format("YYYY-MM-DD") <= endDay ||
  //         moment(item.updatedAt).format("YYYY-MM-DD") <= endDay)
  //     );
  //   });
  // }

  const onChangeSearch = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    setLoading(true);
    props.getAllAdminOffers(
      token,
      onSuccessGetAdminOffer,
      onErrorGetAdminOffer,
      moment().subtract(30, 'days').format('YYYY-MM-DD'),
      moment().format('YYYY-MM-DD')
    );
  }, []);

  const [anchorEl, setAnchorEl] = React.useState(null);

  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  const handleClose = () => {
    // setAnchorEl(null);
    setState({
      ...state,
      anchorEl: null,
    });
  };

  const countOnlineOffer = () => {
    let activeCount = 0;
    for (let i = 0; i < props.allSuperAdminOffers.length; i++) {
      if (props.allSuperAdminOffers[i].isOnline) {
        activeCount += 1;
      }
    }
    return activeCount;
  };

  const countOfflineOffer = () => {
    let activeCount = 0;
    for (let i = 0; i < props.allSuperAdminOffers.length; i++) {
      if (!props.allSuperAdminOffers[i].isOnline) {
        activeCount += 1;
      }
    }
    return activeCount;
  };

  const countActiveOffer = () => {
    let activeCount = 0;
    for (let i = 0; i < props.allSuperAdminOffers.length; i++) {
      if (props.allSuperAdminOffers[i].active) {
        activeCount += 1;
      }
    }
    return activeCount;
  };

  const downloadData = {
    headers: [
      { label: 'SR. No.', key: 'serialNo' },
      { label: 'Offers Name', key: 'offers_name' },
      { label: 'Offers Description', key: 'offers_desc' },
      { label: 'Offer Type', key: 'offers_type' },
      { label: 'Start-end Date', key: 'date' },
      { label: 'Discount Type', key: 'discount_type' },
      { label: 'Amount', key: 'amount' },
      { label: 'Main Carousel', key: 'main_carousel' },
      { label: 'Offer Status', key: 'offer_status' },
    ],
    data: filterOffers
      ? filterOffers?.map((ele, index) => {
          return {
            serialNo: `${index}`,
            offers_name: `${ele?.name}`,
            offers_desc: `${ele?.description}`,
            offers_type: `${ele?.isOnline ? 'Online' : 'Offline'}`,
            date: `${moment(ele && ele?.start_date).format(
              'Do MMM, YY'
            )} - ${moment(ele && ele?.end_date).format('Do MMM, YY')}`,
            discount_type: `${
              ele?.isPercentage ? 'Percentage' : 'Fixed Amount'
            }`,
            amount: `${ele?.discount}`,
            main_carousel: `${ele?.send_to_carousel ? 'Active' : 'Inactive'}`,
            offer_status: `${ele?.active ? 'Yes' : 'No'}`,
          };
        })
      : [],
  };

  const [state, setState] = useState({
    restaurantType: '',
    restaurantCity: '',
    anchorEl: null,
  });

  const [restaurantTypeFilter, setRestaurantTypeFilter] = useState('');
  const [restaurantCityFilter, setRestaurantCityFilter] = useState('');

  const [showSearch, setShowSearch] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [searchData, setSearchData] = useState('');

  const onClickDisplaySearch = (e) => {
    e.preventDefault();
    setShowSearch(!showSearch);
    setShowFilter(false);
  };
  const onClickDisplayFilter = (e) => {
    e.preventDefault();
    setShowFilter(!showFilter);
    setDisplaySearch(false);
  };

  /****************************
   * @DESC Filler All Action
   ****************************/
  const onClickSaveFilter = () => {
    setRestaurantTypeFilter(state?.restaurantType);
    setRestaurantCityFilter(state?.restaurantCity);
    setShowFilter(false);
  };

  const onClickResetFilter = () => {
    setRestaurantTypeFilter('');
    setRestaurantCityFilter('');
    setShowFilter(false);
  };

  /**********************************************
   * @DESC Set User and Vendor Information
   **********************************************/
  const [getVendorUserInfo, setVendorUserInfo] = useState([]);
  const [finalVendorFilter, setFinalVendorFilter] = useState(0);
  useEffect(() => {
    setVendorUserInfo(props?.selectRestaurantList);
  }, [props.selectRestaurantList]);

  const vendorUserData = getVendorUserInfo && getVendorUserInfo;
  let filteredDataModal = [];
  useEffect(() => {
    setFinalVendorFilter(filteredDataModal && filteredDataModal.length);
  }, [filteredDataModal]);

  const RenderVendorUserTable = (actionBy) => {
    if (restaurantTypeFilter === '' && restaurantCityFilter === '') {
      filteredDataModal =
        vendorUserData &&
        vendorUserData.filter((getall) => {
          return getall;
        });
    } else if (restaurantTypeFilter !== '') {
      filteredDataModal =
        vendorUserData &&
        vendorUserData.filter(
          (getall) =>
            getall && getall?.primary_restaurant_type === restaurantTypeFilter
        );
    } else if (restaurantCityFilter !== '') {
      filteredDataModal =
        vendorUserData &&
        vendorUserData.filter(
          (getall) => getall && getall?.city === restaurantCityFilter
        );
    }

    if (searchData) {
      let search = new RegExp(searchData, 'i');
      filteredDataModal =
        vendorUserData &&
        vendorUserData.filter((getall) => {
          if (search.test(getall?._id)) {
            return getall;
          } else if (search.test(getall?.restaurant_name)) {
            return getall;
          } else {
            return console.log('No Records founds');
          }
        });
    }
    if (!isEmpty(filteredDataModal)) {
      return filteredDataModal.map((data, index) => (
        <React.Fragment key={index}>
          <ListMerchantTableBody viewAccess="ViewDashboard" userType={data} />
        </React.Fragment>
      ));
    }
  };

  const onOnlineOfferEditClickHandler = (offer) => {
    setLoading(true);
    history.push({
      pathname: `/superadminoffers/edit-admin-online-offer/${offer._id}`,
      state: { editData: offer },
    });
  };
  const onOfflineOfferEditClickHandler = (offer) => {
    history.push(`/superadminoffers/edit-admin-offline-offer/${offer._id}`);
  };

  return (
    <>
      {loading ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid">
            <div className="row">
              <div className="left-side-panel">
                <LeftSideNavigation displayLink={1} />
              </div>
              <div className="super-admin-right-side-panel">
                <HomeReusableTopBarNavigation />
                <div className="super-admin-inside-right-side-panel">
                  <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                    <div className="f24_700_HelveticaNeue">
                      Super Admin Offers
                      <p
                        className="f12-400 opacity5"
                        style={{ fontWeight: 400 }}
                      >
                        View the list of offers created by super admin
                      </p>
                    </div>
                    <NavLink
                      to="/superadminoffers/add-admin-offer"
                      className="px-4 py-2 btn f14-700 new-addcreate-button"
                    >
                      + Add Offer
                    </NavLink>
                  </div>
                  <div className="row mt-3 mb-2">
                    <div className="col-6">
                      <div className="d-flex align-items-center">
                        <Image
                          alt="Search"
                          title="Search"
                          width="80px"
                          src={require('../../../../assets/images/iconButton/newsearchicon.svg')}
                          onClick={() => onClickSearchButtonTop()}
                        />
                        <SortComponent
                          handleClick={handleClick}
                          anchorEl={state.anchorEl}
                          handleClose={handleClose}
                          selectClick={(data) => handleSelect(data)}
                          displayOnlineOffers={'ONLINE_OFFERS'}
                        />
                        <Image
                          src={require('../../../../assets/images/iconButton/filterbtn.svg')}
                          width="80px"
                          alt="Filter"
                          title="Filter"
                          onClick={(e) => onClickDisplayFilter(e)}
                        />
                        <div className="f10-400" align="center">
                          <CSVDownloader
                            filename={'Super Admin Offers'}
                            headers={downloadData.headers}
                            data={downloadData.data}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-6 d-flex justify-content-end">
                      <div className="col-7">
                        <div className="mr-3">
                          <SelectFilter
                            onDateChange={(data, type) =>
                              onDateChangeHandler(data, type)
                            }
                          />
                        </div>
                        {/* <FormControl variant="outlined" fullWidth>
                          <InputLabel id="demo-simple-select-outlined-label">
                            Select date range
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            value={sortByDay}
                            onChange={(e) => {
                              changeSortByDay(e.target.value);
                            }}
                            label="date_range"
                          >
                            {sortByDate.map((data) => {
                              return (
                                <option
                                  value={data.id}
                                  defaultValue={sortByDay}
                                  key={data.id}
                                >
                                  {data.title}
                                </option>
                              );
                            })}
                          </Select>
                        </FormControl> */}
                      </div>
                    </div>
                    <div className="col-12">
                      {displaySearch ? (
                        <React.Fragment>
                          <ZoomDiv>
                            <div className="mt-2">
                              <Paper
                                component="form"
                                className="enSearch2 d-flex w-50"
                                style={{ borderRadius: 50 }}
                              >
                                <IconButton type="submit" aria-label="search">
                                  <SearchIcon />
                                </IconButton>
                                <InputBase
                                  type="search"
                                  placeholder="Search by offer name and coupon code"
                                  className="w-100"
                                  inputProps={{
                                    'aria-label':
                                      'Search by offer name and coupon code',
                                  }}
                                  onChange={onChangeSearch}
                                  value={search}
                                />
                              </Paper>
                            </div>
                          </ZoomDiv>
                        </React.Fragment>
                      ) : null}
                      <SuperAdminFilter
                        extraClass="mt-0"
                        onChange={onChangeSearch}
                        offerType={offerType}
                        status={status}
                        showFilter={showFilter}
                        sortBy={sortBy}
                        handleChangeCode={(e) => setSortBy(e.target.value)}
                        handleShowFilter={handleShowFilter}
                        handleOfferTypeChange={(e) =>
                          setOfferType(e.target.value)
                        }
                        handleStatusChange={(e) => setStatus(e.target.value)}
                        searchClick={searchClick}
                        cancelClick={cancelClick}
                        hide={true}
                      />
                    </div>
                  </div>

                  {/********* @DESC Offer Count *********/}
                  <Row>
                    <Col md={12}>
                      <hr />
                    </Col>
                    <div className="w-100 d-flex justify-content-end mt-3 mb-3">
                      <RightSideCountTop
                        content={[
                          {
                            name: 'Online Offers',
                            value: countOnlineOffer(),
                            backgroundColor: '#FFEDE9',
                            color: '#EE3A23',
                          },
                          {
                            name: 'Offline Offers',
                            value: countOfflineOffer(),
                            backgroundColor: '#EFEBFB',
                            color: '#6F32C9',
                          },
                          {
                            name: 'Active Offers',
                            value: countActiveOffer(),
                            backgroundColor: '#D8F3F4',
                            color: '#138B90',
                          },
                        ]}
                      />
                    </div>
                  </Row>

                  <div className="user-table-reusable-superadmin table-responsive">
                    <Table className="w-100 HideShowTable enMinWidth900">
                      <thead>
                        <tr className="super_admin_all_users_table_head">
                          <th style={{ width: '20%' }} className="f12-700">
                            My Offers/ <br />
                            Offer Type
                          </th>
                          <th style={{ width: '10%' }} className="f12-700">
                            Start
                            <br />
                            Date - Time
                          </th>
                          <th style={{ width: '10%' }} className="f12-700">
                            End
                            <br />
                            Date - Time
                          </th>
                          <th style={{ width: '15%' }} className="f12-700">
                            Discount <br />
                            Type
                          </th>
                          <th style={{ width: '15%' }} className="f12-700">
                            Discount
                          </th>
                          <th style={{ width: '10%' }} className="f12-700">
                            Fixed Amount
                          </th>
                          <th style={{ width: '10%' }} className="f12-700">
                            Main Carousel
                          </th>
                          <th style={{ width: '10%' }} className="f12-700">
                            Status
                          </th>
                          {/* <th style={{ width: "10%" }} className="f12-700">
                            Primary
                          </th> */}
                        </tr>
                      </thead>
                      {filterOffers.slice(start, end).map((offer, index) => (
                        <RenderTableRecords
                          key={index}
                          offer={offer}
                          index={index}
                          classes={classes}
                          toggleFunction={toggleFunction}
                          togglePrimaryFunction={togglePrimaryFunction}
                          handleShowView={handleShowView}
                          handleShowView2={handleShowView2}
                          onOnlineOfferEditClickHandler={
                            onOnlineOfferEditClickHandler
                          }
                          onOfflineOfferEditClickHandler={
                            onOfflineOfferEditClickHandler
                          }
                          mainCarousel={mainCarousel}
                          openMerchantModelPopup={openMerchantModel}
                          handleMerchantModelClosePopup={
                            handleMerchantModelClose
                          }
                          handleMerchantModelShowPopup={() =>
                            handleMerchantModelShow(offer)
                          }
                          restaurantTypeChange={(e) =>
                            setState({
                              ...state,
                              restaurantType: e.target.value,
                            })
                          }
                          restaurantCityChange={(e) =>
                            setState({
                              ...state,
                              restaurantCity: e.target.value,
                            })
                          }
                          setSearchData={(e) => setSearchData(e.target.value)}
                          showSearch={showSearch}
                          searchData={searchData}
                          finalVendorFilter={finalVendorFilter}
                          showFilter={showFilter}
                          getCity={props?.getCity}
                          restaurantType={props?.restaurantType}
                          auth={props.auth.secondary_loader}
                          state={state}
                          onClickDisplaySearch={(e) => onClickDisplaySearch(e)}
                          onClickDisplayFilter={(e) => onClickDisplayFilter(e)}
                          onClickResetFilter={onClickResetFilter}
                          onClickSaveFilter={onClickSaveFilter}
                          vendorUserData={vendorUserData}
                          RenderVendorUserTable={RenderVendorUserTable()}
                        />
                      ))}
                    </Table>
                  </div>
                  {props.allSuperAdminOffers &&
                  props.allSuperAdminOffers.length !== 0 ? (
                    <BasicPagination
                      totalRecords={filterOffers.length}
                      limit={10}
                      batch={page}
                      onBatchChange={(e) => handleBatchChange(e)}
                    />
                  ) : (
                    <> </>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* {props.data.isOnline ? (
                          <ViewOfferDetailsOnline vendorOffer={props.data} />
                        ) : (
                          <ViewOfferDetailsOffline vendorOffer={props.data} />
                        )} */}
          {!data?.isOnline ? (
            <ViewOfferDetailsOfflineAdmin
              onClickCloseView={handleCloseView}
              onClickshowView={showView}
              data={data}
            />
          ) : (
            <ViewOfferDetailsOnlineAdmin
              onClickCloseView={handleCloseView2}
              onClickshowView={showView2}
              data={data}
              handleTab={(e) => handleTab(e)}
              currentTab={selectedTab}
            />
          )}
        </React.Fragment>
      )}
    </>
  );
};

const RenderTableRecords = ({
  classes,
  offer,
  index,
  toggleFunction,
  togglePrimaryFunction,
  handleShowView,
  handleShowView2,
  mainCarousel,
  openMerchantModelPopup,
  handleMerchantModelClosePopup,
  handleMerchantModelShowPopup,
  onOnlineOfferEditClickHandler,
  onOfflineOfferEditClickHandler,

  restaurantTypeChange,
  restaurantCityChange,
  setSearchData,
  showSearch,
  searchData,
  finalVendorFilter,
  showFilter,
  restaurantType,
  getCity,
  auth,
  state,
  onClickDisplaySearch,
  onClickDisplayFilter,
  onClickResetFilter,
  onClickSaveFilter,
  vendorUserData,
  RenderVendorUserTable,
}) => {
  const [show, setShow] = useState(false);
  return (
    <Fragment>
      <tbody key={index}>
        <tr
          className="super_admin_all_users_table_body"
          onClick={() => setShow(!show)}
        >
          <td
            style={{ width: '20%' }}
            onClick={(e) => {
              if (!e) var e = window.event;
              e.cancelBubble = true;
              if (e.stopPropagation) e.stopPropagation();
            }}
          >
            <div className="d-flex align-items-center">
              <div className="text-center d-flex flex-column align-items-center">
                <div className="enImage45">
                  <Image
                    // src={require("../../../../assets/images/UserManagement/offer.png")}
                    src={
                      offer?.photo_thumbnails && offer?.photo_thumbnails?.[0]
                        ? offer?.photo_thumbnails?.[0]
                        : offer?.photos?.[0]
                    }
                    alt="offer img"
                    title="offer img"
                    fluid
                  />
                </div>
                {offer?.isOnline ? (
                  <div className="enSuccessLBL mt-2">Online</div>
                ) : (
                  <div className="enPendingLBL mt-2">Offline</div>
                )}
              </div>
              <div id="read-more-text" className="pl-3 text-break">
                <div className="f12-500">{offer.name}</div>
                <div className="f10-500 opacity5 text-break">
                  <ReadMore
                    children={offer && offer?.description}
                    minLength={30}
                    charLength={
                      offer &&
                      offer?.description !== null &&
                      offer &&
                      offer?.description !== undefined
                        ? offer && offer?.description.length
                        : 10
                    }
                  />
                  {/* <ReadMoreReact
                    text={offer && offer?.description}
                    min={0}
                    ideal={
                      offer && offer?.description.length > 20
                        ? 20
                        : offer && offer?.description.length
                    }
                    max={offer && offer?.description.length}
                    readMoreText={"Read More"}
                  /> */}
                </div>
              </div>
            </div>
          </td>
          <td style={{ width: '10%' }}>
            <div className="f14-400">
              {moment(offer && offer.start_date).format('Do MMM YY')}
              <br />
              {moment(offer && offer.start_date).format('HH:mm a')}
            </div>
          </td>
          <td style={{ width: '10%' }}>
            <div className="f14-400 text-red">
              {moment(offer && offer.end_date).format('Do MMM YY')}
              <br />
              {moment(offer && offer.end_date).format('HH:mm a')}
            </div>
          </td>
          <td style={{ width: '15%' }}>
            <div className="f15-700">
              {offer?.isPercentage !== null && offer?.isPercentage !== undefined
                ? offer.isPercentage
                  ? 'Percentage'
                  : 'Fixed Amount'
                : '_'}
            </div>
          </td>
          <td style={{ width: '15%' }}>
            <div className="f15-700">
              {offer?.isPercentage !== null && offer?.isPercentage !== undefined
                ? offer?.isPercentage
                  ? offer?.discount
                  : '_'
                : '_'}
            </div>
          </td>
          <td style={{ width: '10%' }}>
            <div className="f15-700">
              {offer?.isPercentage !== null && offer?.isPercentage !== undefined
                ? offer?.isPercentage
                  ? '_'
                  : offer?.discount
                : '_'}
            </div>
          </td>
          <td
            style={{ width: '10%' }}
            onClick={(e) => {
              if (!e) var e = window.event;
              e.cancelBubble = true;
              if (e.stopPropagation) e.stopPropagation();
            }}
          >
            <div className="d-flex align-items-center">
              <div className="f12-400 mr-2">
                {offer.send_to_carousel ? 'Active' : 'Inactive'}
              </div>
              <Switch
                focusVisibleClassName={classes.focusVisible}
                disableRipple
                classes={{
                  root: classes.root,
                  switchBase: classes.switchBase,
                  thumb: classes.thumb,
                  track: classes.track,
                  checked: classes.checked,
                }}
                onChange={() =>
                  mainCarousel(
                    offer?.send_to_carousel,
                    offer?.active,
                    offer?._id
                  )
                }
                checked={offer.send_to_carousel}
              />
              {/* <Switch
                onChange={() =>
                  mainCarousel(
                    offer?.send_to_carousel,
                    offer?.active,
                    offer?._id
                  )
                }
                checked={offer.send_to_carousel}
                offColor="#EEEEEE"
                onColor="#EEEEEE"
                offHandleColor="#212121"
                onHandleColor="#59F832"
                handleDiameter={24}
                uncheckedIcon={false}
                checkedIcon={false}
                height={15}
                width={41}
                boxShadow="-2px 0px 5px #0000003B"
                activeBoxShadow="-2px 0px 5px #0000003B"
                id="material-switch"
              /> */}
            </div>
          </td>
          <td
            style={{ width: '10%' }}
            onClick={(e) => {
              if (!e) var e = window.event;
              e.cancelBubble = true;
              if (e.stopPropagation) e.stopPropagation();
            }}
          >
            <div className="d-flex align-items-center">
              <div className={`${offer.active ? 'f12-400' : 'f12-700'} mr-2`}>
                No
              </div>
              <Switch
                focusVisibleClassName={classes.focusVisible}
                disableRipple
                classes={{
                  root: classes.root,
                  switchBase: classes.switchBase,
                  thumb: classes.thumb,
                  track: classes.track,
                  checked: classes.checked,
                }}
                onChange={() => toggleFunction(offer.active, offer._id)}
                checked={offer.active}
              />
              {/* <Switch
                onChange={() => toggleFunction(offer.active, offer._id)}
                checked={offer.active}
                offColor="#EEEEEE"
                onColor="#EEEEEE"
                offHandleColor="#212121"
                onHandleColor="#59F832"
                handleDiameter={24}
                uncheckedIcon={false}
                checkedIcon={false}
                height={15}
                width={41}
                boxShadow="-2px 0px 5px #0000003B"
                activeBoxShadow="-2px 0px 5px #0000003B"
                id="material-switch"
              /> */}
              <div className={`${offer.active ? 'f12-700' : 'f12-400'} mr-2`}>
                Yes
              </div>
            </div>
          </td>
          {/* <td style={{ width: "10%" }}>
            <div className="d-flex align-items-center">
              <div className="f12-400 mr-2">No</div>
              <Switch
                onChange={() =>
                  togglePrimaryFunction(offer?.mark_as_primary, offer?._id)
                }
                checked={offer?.mark_as_primary}
                offColor="#EEEEEE"
                onColor="#EEEEEE"
                offHandleColor="#212121"
                onHandleColor="#59F832"
                handleDiameter={24}
                uncheckedIcon={false}
                checkedIcon={false}
                height={15}
                width={41}
                boxShadow="-2px 0px 5px #0000003B"
                activeBoxShadow="-2px 0px 5px #0000003B"
                id="material-switch"
              />
              <div className="f12-400 mr-2">Yes</div>
            </div>
          </td> */}
        </tr>
        {show && (
          <>
            <tr
              style={{
                backgroundColor: '#fff',
                borderTop: '1px solid #E0E0E0',
              }}
              className="mt-0 pt-0"
            >
              <td style={{ width: '20%' }}>
                <div style={{ borderRight: '1px solid #E0E0E0' }}>
                  <div
                    className="f10-400 mb-2"
                    //color: "#EE3A23",
                  >
                    More details
                  </div>
                  <div className="d-flex">
                    <Button
                      variant="link"
                      className="enIconBtn mr-3"
                      onClick={() =>
                        offer?.isOnline
                          ? handleShowView2(offer)
                          : handleShowView(offer)
                      }
                    >
                      <Image
                        src={require('../../../../assets/images/UserManagement/eye.svg')}
                        alt="View offer"
                        title="View offer"
                        fluid
                      />
                    </Button>
                    <Button
                      variant="link"
                      className="enIconBtn mr-3"
                      onClick={() =>
                        offer?.isOnline
                          ? onOnlineOfferEditClickHandler(offer)
                          : onOfflineOfferEditClickHandler(offer)
                      }
                    >
                      <Image
                        src={require('../../../../assets/images/UserManagement/pencil.svg')}
                        alt="Edit offer"
                        title="Edit offer"
                        fluid
                      />
                    </Button>
                    <SuperAdminOfferDelete offerId={offer._id} />
                    <ShareLinkModal
                      userAppLink={offer?.shareLink?.shortLink || ''}
                      webAppHide={true}
                    />
                    {/* <NavLink
                      className="enIconBtn mr-3"
                      to={`${
                        offer?.isOnline
                          ? `/superadminoffers/edit-admin-online-offer/${offer._id}`
                          : `/superadminoffers/edit-admin-offline-offer/${offer._id}`
                      }`}
                    >
                      <Image
                        src={require("../../../../assets/images/UserManagement/pencil.svg")}
                        alt="Edit offer"
                        title="Edit offer"
                        fluid
                      />
                    </NavLink> */}
                  </div>
                </div>
              </td>
              <td style={{ width: '12%' }}>
                <div className="f10-400 mb-2">
                  Offer Code/
                  <br />
                  Coupon Code
                </div>
                <div className="f12-500 mb-2">{offer?.coupon_code}</div>
              </td>
              <td style={{ width: '12%' }}>
                <div className="f10-400 mb-2">
                  Offer Code
                  <br />
                  Usage Limit
                </div>
                <div className="f12-500 mb-2">
                  {offer?.isOnline ? offer?.maximum_usage_limit : '_'}
                </div>
              </td>
              <td style={{ width: '20%' }}>
                <div className="f10-400 mb-2">Offer Usage Limit Per User</div>
                <div className="f12-500 mb-2">
                  {offer?.isOnline ? offer?.useLimit + ' per ' : ''}
                  {offer?.isOnline
                    ? offer?.useFrequency === 'DAILY'
                      ? 'Day'
                      : offer?.useFrequency === 'WEEKLY'
                      ? 'Week'
                      : offer?.useFrequency === 'MONTHLY'
                      ? 'Month'
                      : 'Year'
                    : ''}
                  {offer?.isOnline ? ' | max ' + offer?.maxUsage : ''}
                </div>
              </td>
              <td style={{ width: '12%' }} className="text-break">
                <div className="f10-400 mb-2">Country</div>
                <div className="f12-500 mb-2">
                  {offer?.isOnline ? offer?.country : '_'}
                </div>
              </td>
              <td style={{ width: '12%' }} className="text-break">
                <div className="f10-400 mb-2">State</div>
                <div className="f12-500 mb-2">
                  {offer?.isOnline ? offer?.state : '_'}
                </div>
              </td>
              <td style={{ width: '12%' }} className="text-break">
                <div className="f10-400 mb-2">City</div>
                <div className="f12-500 mb-2">
                  {offer?.isOnline ? offer?.city : '_'}
                </div>
              </td>
            </tr>
            <tr
              style={{
                backgroundColor: '#fff',
                borderTop: '1px solid #E0E0E0',
              }}
              className="mt-0 pt-0"
            >
              <td style={{ width: '12%' }}>
                <div className="f14-500 mb-2">
                  Min. Order
                  <br />
                  Value
                </div>
                <div className="f12-400 mb-2">
                  {offer?.minimum_order_applied}
                </div>
              </td>
              <td style={{ width: '12%' }}>
                <div className="f14-500 mb-2">
                  Max. Order
                  <br />
                  Value
                </div>
                <div className="f12-400 mb-2">
                  {offer?.maximum_order_applied}
                </div>
              </td>
              <td style={{ width: '12%' }}>
                <div className="f14-500 mb-2">
                  Max. Discount
                  <br />
                  Value
                </div>
                <div className="f12-400 mb-2">
                  {offer?.maximum_discount_applied}
                </div>
              </td>
              <td style={{ width: '12%' }}>
                <div className="f14-500 mb-2">
                  Applicable To
                  <br />
                  Services
                </div>
                <div className="f12-400 mb-2">
                  {offer?.service_type.length <= 0
                    ? '-'
                    : offer?.service_type.map((item, index) => {
                        if (index === 0) {
                          return item;
                        } else if (item) {
                          return ', ' + item;
                        }
                      })}
                </div>
              </td>
              <td style={{ width: '12%' }}>
                <div className="f14-500 mb-2">Views</div>
                <div className="f12-400 mb-2">{offer?.offerViews}</div>
              </td>
              <td style={{ width: '12%' }}>
                <div className="f14-500 mb-2">Used</div>
                <div className="f12-400 mb-2">{offer?.offerUsed}</div>
              </td>
              <td style={{ width: '28%' }} className="text-right">
                {offer?.isOnline ? (
                  <Button
                    className="f10-400 mb-2 bg-transparent border-0"
                    style={{ color: '#2196F3' }}
                    onClick={handleMerchantModelShowPopup}
                  >
                    View list of Merchants
                  </Button>
                ) : null}
                <Modal
                  show={openMerchantModelPopup}
                  onHide={handleMerchantModelClosePopup}
                  backdrop="static"
                  centered={true}
                  size="lg"
                >
                  <Modal.Header closeButton>
                    <Modal.Title className="f16-500">
                      List of Active Merchants
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col md={6} className="d-flex align-items-center">
                        <div className="d-flex align-items-center">
                          <Image
                            alt="Search"
                            title="Search"
                            width="65px"
                            src={require('../../../../assets/images/iconButton/newsearchicon.svg')}
                            onClick={onClickDisplaySearch}
                          />
                          {/* <Image
                            src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                            width="45px"
                            alt="Filter"
                            title="Filter"
                            onClick={onClickDisplayFilter}
                          /> */}
                        </div>
                      </Col>
                      <Col
                        md={6}
                        className="col-md-6 d-flex align-items-center justify-content-end"
                      >
                        <h5 className="f12-400">
                          Total Number of Merchants :{' '}
                          {auth.secondary_loader ? (
                            <div className="ml-2">
                              <Loader
                                type="ThreeDots"
                                color="#00BFFF"
                                height={25}
                                width={25}
                              />
                            </div>
                          ) : (
                            finalVendorFilter && finalVendorFilter
                          )}
                        </h5>
                      </Col>
                      <div className="col-12">
                        {showSearch && (
                          <div className="my-3">
                            <ZoomDiv>
                              <div className="w-25">
                                <Form.Control
                                  type="text"
                                  placeholder="Search"
                                  value={searchData}
                                  onChange={setSearchData}
                                  className="amSearch"
                                />
                              </div>
                            </ZoomDiv>
                          </div>
                        )}
                        {showFilter && (
                          <div
                            className="container-fluid p-4"
                            style={{ backgroundColor: '#ffffff' }}
                          >
                            <Row>
                              <Col md={6}>
                                <Form.Group>
                                  <FormControl
                                    variant="outlined"
                                    className="w-100"
                                  >
                                    <InputLabel htmlFor="outlined-Status">
                                      City
                                    </InputLabel>
                                    <Select
                                      value={state?.restaurantCity}
                                      onChange={restaurantCityChange}
                                      label="City"
                                      inputProps={{
                                        name: 'restaurantCity',
                                        id: 'outlined-Status',
                                      }}
                                      IconComponent={KeyboardArrowDownIcon}
                                    >
                                      <option value={''} disabled>
                                        Select option
                                      </option>
                                      {getCity &&
                                        getCity?.map((data, index) => (
                                          <option value={data} key={index}>
                                            {data}
                                          </option>
                                        ))}
                                    </Select>
                                  </FormControl>
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group>
                                  <FormControl
                                    variant="outlined"
                                    className="w-100"
                                  >
                                    <InputLabel htmlFor="outlined-Status">
                                      Restaurant Type
                                    </InputLabel>
                                    <Select
                                      value={state?.restaurantType}
                                      onChange={restaurantTypeChange}
                                      label="Restaurant Type"
                                      inputProps={{
                                        name: 'restaurantType',
                                        id: 'outlined-Status',
                                      }}
                                      IconComponent={KeyboardArrowDownIcon}
                                    >
                                      <option value={''} disabled>
                                        Select option
                                      </option>
                                      {restaurantType &&
                                        restaurantType.map((data, index) => (
                                          <option value={data?._id} key={index}>
                                            {data?.title}
                                          </option>
                                        ))}
                                    </Select>
                                  </FormControl>
                                </Form.Group>
                              </Col>
                            </Row>
                            <div class="mt-5 d-flex">
                              <button
                                type="button"
                                onClick={() => onClickResetFilter()}
                                class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                                title="Reset Filter"
                              >
                                Reset
                              </button>
                              <button
                                type="button"
                                onClick={() => onClickSaveFilter()}
                                class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                                title="Search Filter"
                              >
                                Search
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                      <Col sm={12}>
                        {auth.secondary_loader ? (
                          <Loader
                            type="ThreeDots"
                            color="#00BFFF"
                            height={25}
                            width={25}
                          />
                        ) : vendorUserData && vendorUserData.length !== 0 ? (
                          <div
                            className="col-12 p-0 user-table-reusable-superadmin my-2"
                            style={{
                              // maxHeight: "400px",
                              // overflow: "auto",
                              border: '1px solid #00000029',
                              borderRadius: '10px',
                            }}
                          >
                            <Table
                              style={{
                                borderSpacing: 0,
                                borderCollapse: 'collapse',
                              }}
                            >
                              <thead>
                                <ListMarchantTableHead viewAccess="ViewDashboard" />
                              </thead>
                              {finalVendorFilter && finalVendorFilter !== 0 ? (
                                <div
                                  id="style-4"
                                  style={{
                                    maxHeight: '400px',
                                    overflow: 'auto',
                                  }}
                                >
                                  {RenderVendorUserTable}
                                </div>
                              ) : (
                                <React.Fragment>
                                  <div className="text-center">
                                    <h3 className="f16-500 opacity5">
                                      NO RECORDS FOUND
                                    </h3>
                                  </div>
                                </React.Fragment>
                              )}
                            </Table>
                          </div>
                        ) : (
                          <React.Fragment>
                            <div className="text-center">
                              <h3 className="f16-500 opacity5">
                                NO RECORDS FOUND
                              </h3>
                            </div>
                          </React.Fragment>
                        )}
                      </Col>
                    </Row>
                  </Modal.Body>
                  {/* <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={handleMerchantModelClosePopup}
                    >
                      Close
                    </Button>
                    <Button
                      variant="primary"
                      onClick={handleMerchantModelClosePopup}
                    >
                      Save Changes
                    </Button>
                  </Modal.Footer> */}
                </Modal>
              </td>
            </tr>
          </>
        )}
      </tbody>
    </Fragment>
  );
};
SuperAdminOffers.propTypes = {
  auth: PropTypes.object.isRequired,
  getAllAdminOffers: PropTypes.func.isRequired,
  changeAdminOfferStatus: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  allSuperAdminOffers: state.superAdminOffers.allSuperAdminOffers,
  getCity: state.superAdminOfflineOnlineOffers?.city,
  selectRestaurantList:
    state?.superAdminOfflineOnlineOffers?.selectedBusinessList?.restaurants,
  restaurantType: state.category?.restaurant_type,
});

export default connect(mapStateToProps, {
  getAllAdminOffers,
  changeAdminOfferStatus,
  super_admin_get_selected_restaurant_list,
  super_admin_get_city,
})(SuperAdminOffers);

export const ReadMore = (props) => {
  const text = props?.children;
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <p className="text">
      {isReadMore ? text && text.slice(0, props?.minLength) : text && text}
      <span
        onClick={toggleReadMore}
        className={
          isReadMore
            ? 'cursor text-danger f10-500'
            : 'read-or-hide cursor f10-500'
        }
        style={{ color: !isReadMore ? '#8a2be2' : '' }}
      >
        {props.charLength >= props?.minLength
          ? isReadMore
            ? '...read more'
            : ' show less'
          : ''}
      </span>
    </p>
  );
};
